"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Default_1 = require("../presets/Default");
exports.DeadCodeInjectionRule = (options) => {
    if (options.deadCodeInjection) {
        options = Object.assign(Object.assign({}, options), { deadCodeInjection: true, stringArray: true });
        if (!options.stringArrayThreshold) {
            options = Object.assign(Object.assign({}, options), { stringArray: true, stringArrayThreshold: Default_1.DEFAULT_PRESET.stringArrayThreshold });
        }
    }
    return options;
};
